module.exports = __webpack_public_path__ + "img/qikkids-logo.c69f1d20.png";